import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { catchError, retry } from 'rxjs/operators';
import { TraceLog } from '../models/traceLog';
import { of } from 'rxjs';

@Injectable({
    providedIn: 'root'
})

export class LogService {

    private _apiSettings = environment.restAPI;
    private _baseServiceUrl = '';

    constructor(@Inject('BASE_URL') baseUrl: string,
        private _httpClient: HttpClient,
    ) {
        this._baseServiceUrl = (this._apiSettings.useStaticUrl ? this._apiSettings.staticUrl : baseUrl) + this._apiSettings.urlSuffix;
    }

    log(source, operation, error, data?) {

        const errorString = JSON.stringify(error);
        const dataString = JSON.stringify(data);

        const trace: TraceLog = {
            eventId: null,
            logDateTime: null,
            source: source,
            operation: operation,
            message: errorString,
            data: dataString
        };

        console.log(new Date() + ": " + JSON.stringify(trace));

        const serviceUrl: string = this._baseServiceUrl + 'Trace/Add';

        this._httpClient.post<TraceLog>(serviceUrl, trace).pipe(
            retry(this._apiSettings.retryCount),
            catchError(err => {
                console.error(err);
                return of(null); // Return an observable with null value
            })
        ).subscribe(response => {
            if (response) {
                console.log('Response received:', response);
            } else {
                console.log('No response received or an error occurred.');
            }
        });
    }
}
